var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PreFunnelTravel',{attrs:{"single-family-type-text":_vm._f("ScString")(_vm.fields.singleFamilyTypeText),"multiple-family-type-text":_vm._f("ScString")(_vm.fields.multipleFamilyTypeText),"choose-family-type-text":_vm._f("ScString")(_vm.fields.chooseFamilyTypeText),"link":_vm._f("ScLink")(_vm.fields.link)}})
}
var staticRenderFns = []

export { render, staticRenderFns }